import { useCallback, useEffect, useRef, useState } from "react";
import { ICreateAskProps } from "./types";
import { DialogComponent } from "@portal/components/organisms/DialogComponent";
import { CreateAskComponent } from "./CreateAskComponent";

/**
 * Component for creating a new ASK account.
 * @param params
 * @returns an interface to create an ASK account.
 */
export const CreateAskDialog = ({ centerId, isDefaultLanguage, setShowAskComponent }: ICreateAskProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isDialogBoxOpen, setIsDialogBoxOpen] = useState(true);

  const OnCancelClick = useCallback(() => {
    setIsDialogBoxOpen(false);
    setShowAskComponent(false);
  }, [setShowAskComponent]);

  useEffect(() => {
    if (buttonRef?.current) buttonRef.current.focus();
  }, [buttonRef]);

  return (
    <DialogComponent
      open={isDialogBoxOpen}
      onClose={() => null}
      panelClassName="top-40 w-[97%] max-w-xl rounded-lg border border-greyBorder dark:border-blueBorderDark p-2 md:p-4 md:max-h-[700px] overflow-auto"
    >
      <CreateAskComponent centerId={centerId} isDefaultLanguage={isDefaultLanguage} cancelClickCallback={OnCancelClick} />
    </DialogComponent>
  );
};
